<script lang="ts" setup>
import type GiftTemplate from '@consumer/types/GiftTemplate'

import GiftlyV1Image from '@consumer/modules/shared/GiftlyV1Image.vue'

const props = defineProps<{
  gift: GiftTemplate
  overrideTagline?: string
}>()
</script>

<template>
  <GiftlyV3Image v-if="gift.giftlyVersion === 3" v-bind="props"/>
  <GiftlyV2Image v-else-if="gift.giftlyVersion === 2" v-bind="props"/>
  <GiftlyV1Image v-else-if="gift.giftlyVersion === 1" v-bind="props"/>
</template>
